module.exports = __webpack_public_path__ + "static/media/gallium.0d06d0be.png";